import {Entity, EntityModel, PagedList} from '../models/entity.model';
import {map, Observable} from 'rxjs';

type Constructor<T> = new (...args: any[]) => T;
type Factory<T> = (...args: any[]) => T;

export class ModelMapper<T extends Entity, TModel extends EntityModel<T>> {
  constructor(protected readonly model: Constructor<TModel> | Factory<TModel>) {}

  create(src: T): TModel {
    if (typeof this.model === "function" && this.model.prototype) {
      return new (this.model as Constructor<TModel>)(src)
    } else {
      return (this.model as Factory<TModel>)(src)
    }
  }

  map(src: T): TModel
  map(src: Observable<T>): Observable<TModel>
  map(src: T | Observable<T>): TModel | Observable<TModel> {
    if (src instanceof Observable) {
      return src.pipe(map(t => this.map(t)))
    }
    return this.create(src)
  }

  mapMany(src: T[]): TModel[] {
    return src.map(s => this.create(s))
  }

  mapList(list: PagedList<T>): PagedList<TModel>
  mapList(list: Observable<PagedList<T>>): Observable<PagedList<TModel>>
  mapList(list: PagedList<T> | Observable<PagedList<T>>): PagedList<TModel> | Observable<PagedList<TModel>>  {
    if (list instanceof Observable) {
      return list.pipe(map(l => this.mapList(l)))
    }
    return {
      count: list.count,
      page: list.page,
      pages: list.pages,
      items: this.mapMany(list.items)
    }
  }
}
